import React from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

import { Link } from "react-router-dom";
function AboutTwoArea() {
  const brandingProgress = 85;
  const digitalMarketProgress = 73;
  const UIUXProgress = 93;
  return (
    <>
      <div className="about-section pb-120 mt-5">
        <div className="container">
          <div className="row g-4 d-flex justify-content-center">
            <div className="col-lg-6 col-md-8 col-sm-8 order-1">
              <div
                className="about-img wow animate fadeInDown"
                data-wow-duration="1.5s"
                data-wow-delay="0.5s"
              >
                <div className="abt-img-tag light-version">
                  <div className="icon">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/images/icon/arrow-black.svg"
                      }
                      alt="images"
                    />
                  </div>
                  <h5>05 Years Experience</h5>
                </div>
                <img
                  src={process.env.PUBLIC_URL + "/images/bg/about21.png"}
                  alt="images"
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-8 col-sm-8 order-2">
              <div
                className="about-card light-version wow animate fadeInDown"
                data-wow-duration="1.5s"
                data-wow-delay="0.5s"
              >
                <div className="about-content">
                  <h5>About Us</h5>
                  <h3>We drive experiences for brands with purpose.</h3>
                  <p>
                    We’re west coast change-makers, in a complex world. The
                    brands we support are positioned to be purposeful and
                    powerful while also fluid.
                  </p>
                  <ul>
                    <li>
                      <Link to={"#"}>
                        <svg
                          width={31}
                          height={13}
                          viewBox="0 0 31 13"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M24 1.45465V6.5V11.5454C24 11.7194 24.2068 11.8104 24.3351 11.6928L30 6.5L24.3351 1.30722C24.2068 1.18963 24 1.28063 24 1.45465Z" />
                          <path d="M1 6C0.723858 6 0.5 6.22386 0.5 6.5C0.5 6.77614 0.723858 7 1 7V6ZM24.3351 1.30722L23.9972 1.67579L23.9972 1.67579L24.3351 1.30722ZM30 6.5L30.3378 6.86858L30.7399 6.5L30.3378 6.13142L30 6.5ZM24.3351 11.6928L24.673 12.0614V12.0614L24.3351 11.6928ZM1 7H24V6H1V7ZM24.5 6.5V1.45465H23.5V6.5H24.5ZM23.9972 1.67579L29.6621 6.86858L30.3378 6.13142L24.673 0.938639L23.9972 1.67579ZM29.6621 6.13142L23.9972 11.3242L24.673 12.0614L30.3378 6.86858L29.6621 6.13142ZM24.5 11.5454V6.5H23.5V11.5454H24.5ZM23.9972 11.3242C24.1897 11.1478 24.5 11.2843 24.5 11.5454H23.5C23.5 12.1544 24.224 12.4729 24.673 12.0614L23.9972 11.3242ZM24.5 1.45465C24.5 1.71567 24.1897 1.85218 23.9972 1.67579L24.673 0.938641C24.224 0.527068 23.5 0.845579 23.5 1.45465H24.5Z" />
                        </svg>
                        Creating with a Special or Unique Process
                      </Link>
                    </li>
                    <li>
                      <Link to={"#"}>
                        <svg
                          width={31}
                          height={13}
                          viewBox="0 0 31 13"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M24 1.45465V6.5V11.5454C24 11.7194 24.2068 11.8104 24.3351 11.6928L30 6.5L24.3351 1.30722C24.2068 1.18963 24 1.28063 24 1.45465Z" />
                          <path d="M1 6C0.723858 6 0.5 6.22386 0.5 6.5C0.5 6.77614 0.723858 7 1 7V6ZM24.3351 1.30722L23.9972 1.67579L23.9972 1.67579L24.3351 1.30722ZM30 6.5L30.3378 6.86858L30.7399 6.5L30.3378 6.13142L30 6.5ZM24.3351 11.6928L24.673 12.0614V12.0614L24.3351 11.6928ZM1 7H24V6H1V7ZM24.5 6.5V1.45465H23.5V6.5H24.5ZM23.9972 1.67579L29.6621 6.86858L30.3378 6.13142L24.673 0.938639L23.9972 1.67579ZM29.6621 6.13142L23.9972 11.3242L24.673 12.0614L30.3378 6.86858L29.6621 6.13142ZM24.5 11.5454V6.5H23.5V11.5454H24.5ZM23.9972 11.3242C24.1897 11.1478 24.5 11.2843 24.5 11.5454H23.5C23.5 12.1544 24.224 12.4729 24.673 12.0614L23.9972 11.3242ZM24.5 1.45465C24.5 1.71567 24.1897 1.85218 23.9972 1.67579L24.673 0.938641C24.224 0.527068 23.5 0.845579 23.5 1.45465H24.5Z" />
                        </svg>
                        A Radical Change
                      </Link>
                    </li>
                    <li>
                      <Link to={"#"}>
                        <svg
                          width={31}
                          height={13}
                          viewBox="0 0 31 13"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M24 1.45465V6.5V11.5454C24 11.7194 24.2068 11.8104 24.3351 11.6928L30 6.5L24.3351 1.30722C24.2068 1.18963 24 1.28063 24 1.45465Z" />
                          <path d="M1 6C0.723858 6 0.5 6.22386 0.5 6.5C0.5 6.77614 0.723858 7 1 7V6ZM24.3351 1.30722L23.9972 1.67579L23.9972 1.67579L24.3351 1.30722ZM30 6.5L30.3378 6.86858L30.7399 6.5L30.3378 6.13142L30 6.5ZM24.3351 11.6928L24.673 12.0614V12.0614L24.3351 11.6928ZM1 7H24V6H1V7ZM24.5 6.5V1.45465H23.5V6.5H24.5ZM23.9972 1.67579L29.6621 6.86858L30.3378 6.13142L24.673 0.938639L23.9972 1.67579ZM29.6621 6.13142L23.9972 11.3242L24.673 12.0614L30.3378 6.86858L29.6621 6.13142ZM24.5 11.5454V6.5H23.5V11.5454H24.5ZM23.9972 11.3242C24.1897 11.1478 24.5 11.2843 24.5 11.5454H23.5C23.5 12.1544 24.224 12.4729 24.673 12.0614L23.9972 11.3242ZM24.5 1.45465C24.5 1.71567 24.1897 1.85218 23.9972 1.67579L24.673 0.938641C24.224 0.527068 23.5 0.845579 23.5 1.45465H24.5Z" />
                        </svg>
                        Possessing Special Skill or Knowledge
                      </Link>
                    </li>
                  </ul>
                  <Link
                    to={`${process.env.PUBLIC_URL}/about-us`}
                    onClick={() =>
                      window.scrollTo({ top: 0, behavior: "smooth" })
                    }
                    className="eg-btn outlined-btn hover-btn"
                  >
                    <span>
                      Read More
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/images/icon/arrow-black.svg"
                        }
                        alt="images"
                      />
                    </span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-md-8 col-sm-8 order-md-3 order-4">
              <div
                className="about-card light-version wow animate fadeInUp"
                data-wow-duration="1.5s"
                data-wow-delay="0.5s"
              >
                <div className="about-content">
                  <h5  className="cusm-front">Why Choose Genius Fixers </h5>
                  <h3  className="cusm-front">We believe that talent and skills do not have borders. </h3>
                  <p  className="cusm-front">
                  If you're looking for a reliable and innovative technology partner, here are some reasons why you should choose Genius Fixers: {" "}
                  </p>
                  <div className="counter-wrapper d-flex justify-content-xl-between justify-content-center flex-wrap gap-2">
                  <ul  className="cusm-front">
                    <li  className="cusm-front">
                      <Link to={"#"}>
                        <svg
                          width={31}
                          height={13}
                          viewBox="0 0 31 13"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M24 1.45465V6.5V11.5454C24 11.7194 24.2068 11.8104 24.3351 11.6928L30 6.5L24.3351 1.30722C24.2068 1.18963 24 1.28063 24 1.45465Z" />
                          <path d="M1 6C0.723858 6 0.5 6.22386 0.5 6.5C0.5 6.77614 0.723858 7 1 7V6ZM24.3351 1.30722L23.9972 1.67579L23.9972 1.67579L24.3351 1.30722ZM30 6.5L30.3378 6.86858L30.7399 6.5L30.3378 6.13142L30 6.5ZM24.3351 11.6928L24.673 12.0614V12.0614L24.3351 11.6928ZM1 7H24V6H1V7ZM24.5 6.5V1.45465H23.5V6.5H24.5ZM23.9972 1.67579L29.6621 6.86858L30.3378 6.13142L24.673 0.938639L23.9972 1.67579ZM29.6621 6.13142L23.9972 11.3242L24.673 12.0614L30.3378 6.86858L29.6621 6.13142ZM24.5 11.5454V6.5H23.5V11.5454H24.5ZM23.9972 11.3242C24.1897 11.1478 24.5 11.2843 24.5 11.5454H23.5C23.5 12.1544 24.224 12.4729 24.673 12.0614L23.9972 11.3242ZM24.5 1.45465C24.5 1.71567 24.1897 1.85218 23.9972 1.67579L24.673 0.938641C24.224 0.527068 23.5 0.845579 23.5 1.45465H24.5Z" />
                        </svg>
                        Experience
                        <p className="cusm-front">We have years of experience in delivering customized technology solutions to businesses of all sizes and industries. Our team of experts has a deep understanding of the latest technologies and can provide you with tailored solutions that meet your specific business needs.</p>
                      </Link>
                    </li>
                    <li  className="cusm-front">
                      <Link to={"#"}>
                        <svg
                          width={31}
                          height={13}
                          viewBox="0 0 31 13"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M24 1.45465V6.5V11.5454C24 11.7194 24.2068 11.8104 24.3351 11.6928L30 6.5L24.3351 1.30722C24.2068 1.18963 24 1.28063 24 1.45465Z" />
                          <path d="M1 6C0.723858 6 0.5 6.22386 0.5 6.5C0.5 6.77614 0.723858 7 1 7V6ZM24.3351 1.30722L23.9972 1.67579L23.9972 1.67579L24.3351 1.30722ZM30 6.5L30.3378 6.86858L30.7399 6.5L30.3378 6.13142L30 6.5ZM24.3351 11.6928L24.673 12.0614V12.0614L24.3351 11.6928ZM1 7H24V6H1V7ZM24.5 6.5V1.45465H23.5V6.5H24.5ZM23.9972 1.67579L29.6621 6.86858L30.3378 6.13142L24.673 0.938639L23.9972 1.67579ZM29.6621 6.13142L23.9972 11.3242L24.673 12.0614L30.3378 6.86858L29.6621 6.13142ZM24.5 11.5454V6.5H23.5V11.5454H24.5ZM23.9972 11.3242C24.1897 11.1478 24.5 11.2843 24.5 11.5454H23.5C23.5 12.1544 24.224 12.4729 24.673 12.0614L23.9972 11.3242ZM24.5 1.45465C24.5 1.71567 24.1897 1.85218 23.9972 1.67579L24.673 0.938641C24.224 0.527068 23.5 0.845579 23.5 1.45465H24.5Z" />
                        </svg>
                        Quality
                        <p className="cusm-front"> We are committed to delivering high-quality solutions that exceed our clients' expectations. We use rigorous quality assurance processes to ensure that our solutions are reliable, scalable, and secure. </p>
                      </Link>
                    </li>
                    <li  className="cusm-front">
                      <Link to={"#"}>
                        <svg
                          width={31}
                          height={13}
                          viewBox="0 0 31 13"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M24 1.45465V6.5V11.5454C24 11.7194 24.2068 11.8104 24.3351 11.6928L30 6.5L24.3351 1.30722C24.2068 1.18963 24 1.28063 24 1.45465Z" />
                          <path d="M1 6C0.723858 6 0.5 6.22386 0.5 6.5C0.5 6.77614 0.723858 7 1 7V6ZM24.3351 1.30722L23.9972 1.67579L23.9972 1.67579L24.3351 1.30722ZM30 6.5L30.3378 6.86858L30.7399 6.5L30.3378 6.13142L30 6.5ZM24.3351 11.6928L24.673 12.0614V12.0614L24.3351 11.6928ZM1 7H24V6H1V7ZM24.5 6.5V1.45465H23.5V6.5H24.5ZM23.9972 1.67579L29.6621 6.86858L30.3378 6.13142L24.673 0.938639L23.9972 1.67579ZM29.6621 6.13142L23.9972 11.3242L24.673 12.0614L30.3378 6.86858L29.6621 6.13142ZM24.5 11.5454V6.5H23.5V11.5454H24.5ZM23.9972 11.3242C24.1897 11.1478 24.5 11.2843 24.5 11.5454H23.5C23.5 12.1544 24.224 12.4729 24.673 12.0614L23.9972 11.3242ZM24.5 1.45465C24.5 1.71567 24.1897 1.85218 23.9972 1.67579L24.673 0.938641C24.224 0.527068 23.5 0.845579 23.5 1.45465H24.5Z" />
                        </svg>
                        Innovation<p className="cusm-front"> We are constantly exploring new and innovative ways to leverage technology to solve complex business problems. Our team stays up to date with the latest advancements in technology and can help you stay ahead of the competition.</p> 
                      </Link>
                    </li>




                    <li  className="cusm-front">
                      <Link to={"#"}>
                        <svg
                          width={31}
                          height={13}
                          viewBox="0 0 31 13"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M24 1.45465V6.5V11.5454C24 11.7194 24.2068 11.8104 24.3351 11.6928L30 6.5L24.3351 1.30722C24.2068 1.18963 24 1.28063 24 1.45465Z" />
                          <path d="M1 6C0.723858 6 0.5 6.22386 0.5 6.5C0.5 6.77614 0.723858 7 1 7V6ZM24.3351 1.30722L23.9972 1.67579L23.9972 1.67579L24.3351 1.30722ZM30 6.5L30.3378 6.86858L30.7399 6.5L30.3378 6.13142L30 6.5ZM24.3351 11.6928L24.673 12.0614V12.0614L24.3351 11.6928ZM1 7H24V6H1V7ZM24.5 6.5V1.45465H23.5V6.5H24.5ZM23.9972 1.67579L29.6621 6.86858L30.3378 6.13142L24.673 0.938639L23.9972 1.67579ZM29.6621 6.13142L23.9972 11.3242L24.673 12.0614L30.3378 6.86858L29.6621 6.13142ZM24.5 11.5454V6.5H23.5V11.5454H24.5ZM23.9972 11.3242C24.1897 11.1478 24.5 11.2843 24.5 11.5454H23.5C23.5 12.1544 24.224 12.4729 24.673 12.0614L23.9972 11.3242ZM24.5 1.45465C24.5 1.71567 24.1897 1.85218 23.9972 1.67579L24.673 0.938641C24.224 0.527068 23.5 0.845579 23.5 1.45465H24.5Z" />
                        </svg>
                        Customer Service<p className="cusm-front">  We believe that strong relationships with our clients are key to our success. We provide exceptional customer service and support to ensure that our clients are satisfied with our solutions and have a positive experience working with us. </p> 
                      </Link>
                    </li>



                    <li  className="cusm-front">
                      <Link to={"#"}>
                        <svg
                          width={31}
                          height={13}
                          viewBox="0 0 31 13"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M24 1.45465V6.5V11.5454C24 11.7194 24.2068 11.8104 24.3351 11.6928L30 6.5L24.3351 1.30722C24.2068 1.18963 24 1.28063 24 1.45465Z" />
                          <path d="M1 6C0.723858 6 0.5 6.22386 0.5 6.5C0.5 6.77614 0.723858 7 1 7V6ZM24.3351 1.30722L23.9972 1.67579L23.9972 1.67579L24.3351 1.30722ZM30 6.5L30.3378 6.86858L30.7399 6.5L30.3378 6.13142L30 6.5ZM24.3351 11.6928L24.673 12.0614V12.0614L24.3351 11.6928ZM1 7H24V6H1V7ZM24.5 6.5V1.45465H23.5V6.5H24.5ZM23.9972 1.67579L29.6621 6.86858L30.3378 6.13142L24.673 0.938639L23.9972 1.67579ZM29.6621 6.13142L23.9972 11.3242L24.673 12.0614L30.3378 6.86858L29.6621 6.13142ZM24.5 11.5454V6.5H23.5V11.5454H24.5ZM23.9972 11.3242C24.1897 11.1478 24.5 11.2843 24.5 11.5454H23.5C23.5 12.1544 24.224 12.4729 24.673 12.0614L23.9972 11.3242ZM24.5 1.45465C24.5 1.71567 24.1897 1.85218 23.9972 1.67579L24.673 0.938641C24.224 0.527068 23.5 0.845579 23.5 1.45465H24.5Z" />
                        </svg>
                        Proven Track Record<p  className="cusm-front">  Our portfolio of successful projects and long-term relationships with our clients speaks for itself. We have a proven track record of delivering customized solutions that meet and exceed our clients' expectations.  </p> 
                      </Link>
                    </li>


                    <li  className="cusm-front">
                      <Link to={"#"}>

                       <p  className="cusm-front">At Genius Fixers, we are committed to providing our clients with the highest quality technology solutions and exceptional customer service. Contact us today to learn more about how we can help your business grow and succeed. </p>
                      </Link>
                    </li>

                  </ul>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-lg-6 col-md-8 col-sm-8 col-sm-8 order-md-4 order-3 d-lg-block d-none">
              <div
                className="about-img wow animate fadeInUp"
                data-wow-duration="1.5s"
                data-wow-delay="0.5s"
              >
                <img
                  src={process.env.PUBLIC_URL + "/images/bg/about22.png"}
                  alt="images"
                />
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutTwoArea;
